/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-curly-newline */
import React from 'react';
import { Link } from 'react-router-dom';
import {
  FaRegQuestionCircle,
  FaRegCheckCircle,
  FaRegMoneyBillAlt,
  FaRegThumbsUp,
  FaBan,
  FaRegClock,
  FaRegCalendarCheck,
} from 'react-icons/fa';
// import { Container } from './styles';

import { Colors } from '../../styles/constants';

import Button from '../Button';

import {
  IFilaChamado,
  IListaAgendamentosHojeDTO,
} from '../../pages/AgendaAtendimento';
import { CONFIRMACAO_AGENDA, STATUS_AGENDA } from '../../utils/funcoes';
import { useAuth } from '../../hooks/auth';

interface IIcons {
  [key: string]: JSX.Element;
}

const icons: IIcons = {
  ban: <FaBan size={15} />,
  question: <FaRegQuestionCircle size={15} />,
  check: <FaRegCheckCircle size={15} />,
  money: <FaRegMoneyBillAlt size={15} />,
  clock: <FaRegClock size={15} />,
  thumbs: <FaRegThumbsUp size={15} />,
  calendar: <FaRegCalendarCheck size={15} />,
};

type listaProps = {
  listaEspera: IListaAgendamentosHojeDTO[];
  dadosBusca: {
    dataAgenda: string;
    codigoAgenda: string | undefined;
    somenteLista: boolean;
  };
  chamar(pacNome: string): void;
  chamarPainel(dados: IFilaChamado): void;
  abrirHistorico(pacCodigo: number): void;
  sala?: string;
  exibeBotoesAcao?: boolean;
};
const ListaAtendimentoConsulta: React.FC<listaProps> = ({
  listaEspera,
  dadosBusca,
  chamar,
  chamarPainel,
  abrirHistorico,
  sala = '',
  exibeBotoesAcao = true,
}) => {
  const { clinica } = useAuth();
  console.log(listaEspera);
  return (
    <>
      {listaEspera && listaEspera.length > 0 ? (
        <table
          className="table table-hover table-sm table-font-small"
          style={{ borderWidth: '0px' }}
        >
          <thead>
            <tr className="bg-light" style={{ fontSize: 'Small' }}>
              <th scope="col">&nbsp;</th>
              <th scope="col">Horário</th>
              <th scope="col">Liberado às</th>
              <th scope="col">Paciente</th>
              <th scope="col">Idade</th>
              <th scope="col">Celular</th>
              <th scope="col">Procedimento</th>
              {(exibeBotoesAcao || clinica.CliUsaPainel) && (
                <th scope="col">Ação</th>
              )}
            </tr>
          </thead>
          <tbody>
            {listaEspera.map((lista: IListaAgendamentosHojeDTO) => (
              <tr
                key={lista.AgeCodigo}
                style={{
                  fontSize: 'Small',
                  height: '30px',
                  color:
                    lista.AgeStatus === STATUS_AGENDA.ATENDIDO
                      ? Colors.success
                      : '#000',
                }}
                className={`bg-light `}
              >
                <td
                  style={{
                    width: '80px',
                    color: lista.icone?.color,
                    textAlign: 'center',
                  }}
                >
                  {icons[lista.icone?.icon || 'question']}{' '}
                  {lista.AgeStatus === STATUS_AGENDA.PAGAMENTO_ANTECIPADO &&
                    lista.AgeConfirmado < CONFIRMACAO_AGENDA.NAO_VAI
                    ? icons[
                    lista.AgeConfirmado ===
                      CONFIRMACAO_AGENDA.AGUARDANDO_CONFIRMACAO
                      ? 'question'
                      : 'check'
                    ]
                    : ''}
                </td>
                <td style={{ width: '80px' }}>{lista.horario}</td>
                <td style={{ width: '80px' }}>{lista.liberado}</td>
                <td>
                  {lista.PacNomeSocial.trim() !== ''
                    ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                    : lista.PacNome}
                </td>
                <td style={{ width: '100px' }}>{`${lista.idade || ''}`}</td>
                <td style={{ width: '120px' }}>
                  {`${lista.celular || lista.PacCelular}`}
                </td>
                <td>{lista.Procedimento}</td>
                {(exibeBotoesAcao || clinica.CliUsaPainel) && (
                  <td className="p-0" style={{ width: '330px' }}>
                    {exibeBotoesAcao && (
                      <Link
                        className={`btn btn-primary ${lista.AgeStatus <
                            STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                            lista.AgeStatus !== STATUS_AGENDA.PAGAMENTO_ANTECIPADO
                            ? 'd-none'
                            : ''
                          }`}
                        style={{
                          height: '23px',
                          lineHeight: 1,
                          padding: '4px 16px',
                          fontSize: '14px',
                        }}
                        to={`/pacienteAtendimento/${lista.AgeCodigo.toString()}?agenda=${dadosBusca.codigoAgenda
                          }&data=${dadosBusca.dataAgenda}&somenteLista=${dadosBusca.somenteLista
                          }`}
                      >
                        {lista.atendido ? 'Atendido' : 'Atender'}
                      </Link>
                    )}
                    {exibeBotoesAcao && !lista.AgeTelemedicina && (
                      <>
                        {!clinica.CliUsaPainel && (
                          <Button
                            type="button"
                            variant="primary-outline"
                            className={`py-0 ${lista.atendido ||
                              (lista.AgeStatus <
                                STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                                lista.AgeStatus !==
                                STATUS_AGENDA.PAGAMENTO_ANTECIPADO)
                              ? 'd-none'
                              : ''
                              }`}
                            style={{ height: '23px' }}
                            onClick={() =>
                              chamar(
                                lista.PacNomeSocial.trim() !== ''
                                  ? `Nome Social: ${lista.PacNomeSocial} - ${lista.PacNome}`
                                  : lista.PacNome,
                              )
                            }
                            disabled={
                              (sala === '' && clinica.CliUsaPainel) ||
                              clinica.CliCodigo !== lista.ConClinica
                            }
                          >
                            Chamar Paciente
                          </Button>
                        )}
                        {clinica.CliUsaPainel && (
                          <Button
                            type="button"
                            variant="primary-outline"
                            className={`py-0 ${lista.atendido ||
                                (lista.AgeStatus <
                                  STATUS_AGENDA.AGUARDANDO_ATENDIMENTO &&
                                  lista.AgeStatus !==
                                  STATUS_AGENDA.PAGAMENTO_ANTECIPADO)
                                ? 'd-none'
                                : ''
                              }`}
                            style={{ height: '23px' }}
                            onClick={() =>
                              chamarPainel({
                                AgeCodigo: lista.AgeCodigo,
                                CliCodigo: lista.ConClinica,
                                PacCodigo: lista.PacCodigo,
                                PacNome:
                                  lista.PacNomeSocial.trim() !== ''
                                    ? lista.PacNomeSocial
                                    : lista.PacNome,
                                Sala: sala,
                                Texto: `${lista.PacNomeSocial.trim() !== ''
                                  ? lista.PacNomeSocial
                                  : lista.PacNome
                                  }, ${sala}`,
                              })
                            }
                            disabled={sala === '' ||
                              clinica.CliCodigo !== lista.ConClinica}
                          >
                            Chamar Paciente
                          </Button>
                        )}
                      </>
                    )}

                    {lista.AgeTelemedicina && (
                      <div
                        style={{
                            display: 'inline-block',
                            justifyContent: 'center',
                            padding: '0px 8px',
                          }}
                      >
                        <div
                          style={{
                              display: 'flex',
                              backgroundColor: '#e7a6a6',
                              flexDirection: 'row',
                              alignItems: 'center',
                              padding: '4px 10px',
                              borderRadius: '10px',
                            }}
                        >
                          <div
                            style={{
                                backgroundColor: 'red',
                                borderRadius: '9999px',
                                width: '8px',
                                height: '8px',
                              }}
                          />
                          <span
                            style={{
                                color: '#910606',
                                paddingLeft: '10px',
                              }}
                          >
                            Telemedicina
                          </span>
                        </div>
                      </div>
                    )}

                    <Button
                      type="button"
                      variant="primary-outline"
                      className="py-0"
                      style={{ height: '23px' }}
                      onClick={() => abrirHistorico(lista.PacCodigo)}
                      title={lista.PacCodigo.toString()}
                    >
                      Histórico
                    </Button>
                  </td>
                )}
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginTop: '5%',
          }}
        >
          <span>
            <h3>
              Médico não possui agenda configurada para atender em consultório
            </h3>
          </span>
        </div>
      )}
    </>
  );
};
export default ListaAtendimentoConsulta;
